var eventProgram = function() {

	var
		programDropdown,
		stages,
		currentStage,
    initialWindowWidth;

	var _init = function() {
		programDropdown = document.getElementById('programDropdown');
		stages          = document.querySelectorAll('.l-program__programBar');
		stages          = Array.prototype.slice.call(stages);
		currentStage    = programDropdown.options[programDropdown.selectedIndex].value;

    initialWindowWidth = _getWindowWidth();

		_addEventListeners();
	}

  var _getWindowWidth = function() {
    return window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
  }

	var _addEventListeners = function() {
    if (window.matchMedia('(max-width: 768px)').matches) {
			_setStage(currentStage);
		}

		window.addEventListener('resize', function() {
			if (window.matchMedia('(min-width: 768px)').matches) {
				stages.forEach(function(element,index) {
					element.style.display = 'block';
				});
			} else if (_getWindowWidth() != initialWindowWidth) {
        // Resize on mobile is fired also when address bar hides on scroll
				_setStage(currentStage);
			}
		})

		programDropdown.addEventListener('change', function() {
			var selectedStage = this.options[this.selectedIndex].value;
			_setStage(selectedStage);
		}, false)

	}

	var _setStage = function(stage) {

		stages.forEach(function(element,index) {
			var stageName = element.getAttribute('data-attr');

			if(stageName == stage) {
				element.style.display = 'block';
			} else {
				element.style.display = 'none';
			}
		})

	}

	return {
		init: _init
	}

}()

var programEvent = document.getElementById('programEvent');

if(programEvent) {
	eventProgram.init();
}



// WEBPACK FOOTER //
// ./resources/assets/js/partials/ProgramEvent.js